import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

const WhitelistedEmailSchema = z.object({
  id: z.string(),
  email: z.email(),
  createdDate: z.string(),
  createdByEmail: z.email(),
  updatedDate: z.string().nullable(),
  updatedByEmail: z.email().nullable(),
});

export type WhitelistedEmail = z.infer<typeof WhitelistedEmailSchema>;

const WhitelistedEmailsResponseSchema = z.object({
  data: z.object({
    items: z.array(WhitelistedEmailSchema),
  }),
});

export type WhitelistedEmailsResponse = z.infer<
  typeof WhitelistedEmailsResponseSchema
>;

export type WhitelistedEmailsQueryResult = WhitelistedEmail[];

export const getWhitelistedEmailsQueryOptions = defaultClient.query({
  url: 'data-ingestion/whitelisted-emails/' as const,
  method: 'GET',
  responseSchema: WhitelistedEmailsResponseSchema,
  processResponse(data): WhitelistedEmailsQueryResult {
    return data.data.items;
  },
  keyPrefix: ['whitelistedEmails'],
});

const CreateWhitelistedEmailPayloadSchema = z.object({
  email: z.email().trim(),
});

export type CreateWhitelistedEmailPayload = z.infer<
  typeof CreateWhitelistedEmailPayloadSchema
>;

export const createWhitelistedEmail = defaultApi.declareEndpoint({
  url: 'data-ingestion/whitelisted-emails/' as const,
  method: 'POST',
  requestSchema: CreateWhitelistedEmailPayloadSchema,
  responseSchema: z.object({}),
});

const UpdateWhitelistedEmailPayloadSchema = z.object({
  email: z.email().trim(),
});

export type UpdateWhitelistedEmailPayload = z.infer<
  typeof UpdateWhitelistedEmailPayloadSchema
>;

export const updateWhitelistedEmail = defaultApi.declareEndpoint({
  url: 'data-ingestion/whitelisted-emails/$id/' as const,
  method: 'POST',
  requestSchema: UpdateWhitelistedEmailPayloadSchema,
  responseSchema: z.object({}),
});

export const deleteWhitelistedEmail = defaultApi.declareEndpoint({
  url: 'data-ingestion/whitelisted-emails/$id/' as const,
  method: 'DELETE',
  responseSchema: z.string(),
});
